import { delData, getData, postData, patchData } from '../../../utils/fetch-api-util';
import { ShopCategoriesType } from '../../../types/shopCategories';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface ShopCategoriesRequestParams {
  take?: number;
  page?: number;
  country?: string;
}

export interface ShopCategoriesTypeResponse {
  shopCategories: ShopCategoriesType[];
}

export interface createShopCategoriesType {
  title: string;
  ctaLink: string;
  country: string;
}

interface SuccessResponse {
  success: boolean;
}

export interface SortShopCategoriesPayload {
  sortOrderList: {
    id: string;
    sortOrder: number;
  }[];
}

export interface UpdateShopCategoriesPayload {
  title: string;
  ctaLink: string;
  id: string;
}

export const getShopCategoriesListRepository = async (
  data?: ShopCategoriesRequestParams,
): Promise<ShopCategoriesTypeResponse> => {
  const response = await getData<ShopCategoriesRequestParams, ShopCategoriesTypeResponse>(
    API_URLS.SHOP_CATEGORY_LIST,
    data,
  );
  return response.data;
};

export const postCreateShopCategoriesRepository = async (payload: createShopCategoriesType): Promise<void> => {
  await postData<createShopCategoriesType, SuccessResponse>(API_URLS.SHOP_CATEGORY_API, payload);
};

export const patchActiveShopCategoriesRepository = async (payload: {
  disabled: boolean;
  id: string;
}): Promise<void> => {
  await patchData<{ disabled: boolean }, SuccessResponse>(
    API_URLS.SHOP_CATEGORY_ACTIVE_URL_WITH_ID(payload?.id || ''),
    {
      disabled: !!payload?.disabled,
    },
  );
};

export const updateShopCategoriesRepository = async (payload: UpdateShopCategoriesPayload): Promise<void> => {
  if (payload?.id != null) {
    await patchData<UpdateShopCategoriesPayload, SuccessResponse>(
      API_URLS.SHOP_CATEGORY_URL_WITH_ID(payload?.id),
      payload,
    );
  }
};

export const deleteShopCategoriesRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.SHOP_CATEGORY_URL_WITH_ID(id));
};

export const postSortShopCategoriesRepository = async (payload: SortShopCategoriesPayload): Promise<void> => {
  await postData<SortShopCategoriesPayload, SuccessResponse>(API_URLS.SHOP_CATEGORY_SORT, payload);
};
